import React from 'react';

// ----------------------------------------------------------------------

import CommonDelete from '@common/CommonDelete';
import Store from '@data/Store';

import { deleteCoinByIdService } from '../coin.services';

// ----------------------------------------------------------------------

export const CoinDelete = ({ closeModal, id, message }) => {
  const { language } = Store;

  const handleDelete = () => {
    deleteCoinByIdService({ id }).then(() => {
      closeModal();
    });
  };

  return (
    <CommonDelete
      language={language}
      closeModal={closeModal}
      onDelete={handleDelete}
      message={message}
    />
  );
};

export default CoinDelete;
